import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react'
import { Link, useLocation, useParams } from 'react-router-dom'
import dayjs from 'dayjs'
import { LinkIcon } from 'src/components/Icons/FileType'
import isNumber from 'lodash/isNumber'
import {
  AUDIT_RESULT,
  ControlTest,
  OETestProcedureResult,
  OeTestStatus,
  REASON_SOURCE,
} from '@trustero/trustero-api-web/lib/audit/auditbot_pb'
import { SubsectionAccordionItemComponent } from 'src/components/Reusable/Accordions/ShowPage/Subsections/SubsectionAccordion.components'
import log from 'loglevel'
import { faRefresh } from '@fortawesome/free-solid-svg-icons'
import {
  AuditBotShowControlCounts,
  AuditBotShowControlCountsContainer,
} from 'src/pages/AuditBot/show/AuditBotShowPage.styles'
import { CitationLink } from 'src/pages/SecurityQuestionnaire/show/securityQuestionnaireAccordion.components'
import { SmallStyledSubsectionAccordionIcon } from 'src/components/Reusable/Accordions/ShowPage/Subsections/SubsectionAccordion.styles'
import { AuditRunContext } from 'src/pages/AuditBot/context/AuditRunContext'
import {
  useReviewControlTestResult,
  useStartAuditRun,
} from 'src/pages/AuditBot/AuditBot.hooks'
import { MarkControlTestCurrentButton } from 'src/pages/AuditBot/MarkControlTestsCurrent'
import { ToastPrompts, showInfoToast } from 'src/Utils/helpers/toast'
import { TextButton } from 'src/components/Reusable/Buttons/TextButton'
import { useAnalytics } from 'src/analytics/useAnalytics'
import {
  CONTROL_CHECK_ERRORS,
  CONTROL_CHECK_ERROR_MAP,
  HIDE_CONTROL_CHECK_REASONS,
  HIDE_CONTROL_CHECK_REASON_MAP,
} from 'src/pages/AuditBot/AuditBot.constants'
import { AuditRunTitle } from 'src/pages/AuditBot/AuditBot.components'
import {
  ControlsAbsoluteRoutes,
  ExamineAndTestAbsoluteRoutes,
  RequestsAbsoluteRoutes,
} from 'src/components/Reusable/RootPage/RootPage.constants'
import { useModalState } from 'src/Modal/ModalStateContext'
import { ModalFormId } from 'src/components/ModalForms'
import { useCurrentControlTestContext } from 'src/pages/AuditBot/context/CurrentControlTestContext'
import { useTypewriter } from 'src/Utils/globalHooks'
import { useCanPerformAction } from 'src/app/AppAuth/AppAuth.hooks'
import {
  formatTimestamp,
  formatTimestampFromNumber,
} from 'src/Utils/formatDate'
import { DATE_FORMATS } from 'src/Utils/dateConstants'
import { Markup } from 'src/components/Reusable/Text/Markup'
import { Dropdown } from 'react-bootstrap'
import { Tooltip } from 'src/components/Reusable/Tooltip'
import { SimpleIconButton } from 'src/components/Reusable/Buttons/SimpleIconButton'
import { Pill } from 'src/components/Reusable/Pill'
import { FlexAlign, FlexRow } from 'src/components/Reusable/Flex'
import {
  Source,
  SOURCE_RESULT,
} from '@trustero/trustero-api-web/lib/source/source_pb'
import { GatekeeperFlag, IsGatekeeperEnabled } from 'src/context/Gatekeeper'
import { useDocumentSourceContext } from 'src/context/DocumentSource/DocumentSourceContext'
import { TableListLoader } from 'src/components/Reusable/ContentLoaders/TableListLoader'
import { openInNewTab } from 'src/Utils/globalHelpers'
import {
  DropdownSVG,
  EditSVG,
  InfoSVG,
  ErrorSVG,
} from 'src/components/Icons/Basic'
import { SectionTitle } from 'src/components/Reusable/Text/Text.styles'
import {
  DocumentSourcePolicyIcon,
  DocumentSourceRelevantDate,
  SourceContainer,
  SourceDeleted,
  SourceSummary,
} from 'src/components/Reusable/Sources/sources.styles'
import { LearnMoreLink } from 'src/components/Reusable/Text/Link'
import { useArtifact } from 'src/pages/TrusteroIntelligence/conversation/chatConversation.hooks'
import { OperatingEffectivenessArtifactSources } from 'src/pages/TrusteroIntelligence/artifacts/AuditScan/AuditScanArtifact.components'
import {
  OeControlGap,
  OeControlTestDetermination,
  OeControlTestGaps,
  OeControlTestResult,
} from '@trustero/trustero-api-web/lib/artifact/artifact_pb'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import { ListDocumentRequestsRequest } from '@trustero/trustero-api-web/lib/request/request_pb'
import { StringValue } from 'google-protobuf/google/protobuf/wrappers_pb'
import palette from 'src/designSystem/variables/palette'
import { Spinner } from 'src/Throbber/Spinner'
import { MappingsSectionCTA } from 'src/components/Reusable/Mappings/Mappings.styles'
import { useControl } from 'src/components/async/model/control'
import { useUsers } from 'src/components/async/Users'
import {
  controlTestSource,
  useBulkCreateRequestsFromOeArtifact,
  useDocumentRequests,
} from 'src/components/async/DocumentRequest/useDocumentRequests'
import { getOeTestTitle } from 'src/Utils/helpers/string.helpers'
import {
  ControlCheckPassBody,
  DocumentsReadyCheckContainer,
  DocumentsReadyCheckHeader,
} from '../AuditBotSubSectionAccordion.styles'
import {
  OeLiveTestAccordionItem,
  isControlQueued,
  OeQueuedIcon,
  OeRunningSpinner,
  OeHeaderNarration,
} from '../../../reusable/OeLiveStatus'
import {
  getCheckResultIcon,
  getCheckResult,
  CHECK_RESULT_TYPE,
  getOrderedControlChecks,
  getControlCheckOtherIcon,
  getControlCheckOtherReason,
  cleanTestProcedureDescription,
  getOESourceResultIcon,
  getOperatingEffectivenessDetailText,
  getControlPolicyMatchDetailText,
  getControlCheckSourceLink,
  getTestTableExplanationText,
  getControlOeArtifactId,
  getControlTestName,
  getControlCheckAccordionKey,
} from './AuditBotControlChecks.helpers'
import {
  CONTROL_TEST_NAMES,
  ControlResultCountsType,
  GAP_TYPE_TO_LABEL,
  PASSED_CONTROL_CHECK_TEXT,
} from './AuditBotControlChecks.constants'
import {
  ControlCheckButtonGroup,
  ControlCheckCopyIcon,
  ControlCheckCopyMenuDropdown,
  ControlCheckDateContainer,
  ControlCheckDescriptionRow,
  ControlCheckEditIcon,
  ControlCheckEroConcernedIcon,
  ControlCheckEroIcon,
  ControlCheckEroText,
  ControlCheckHeaderButtonsWrapper,
  ControlCheckMarkup,
  ControlCheckResultContainer,
  ControlCheckSourcesContainer,
  ControlCheckSourceTestTableButton,
  ControlCheckTestAccordion,
  ControlCheckTestAccordionBody,
  ControlCheckTestAccordionHeader,
  ControlCheckTestAccordionItem,
  ControlCheckTestProcedureBody,
  ControlCheckTestProcedureContainer,
  ControlCheckTestProcedureDescription,
  ControlCheckTestProcedureIcon,
  ControlCheckTestProcedureNumber,
  MarkAsReviewedButton,
  ReviewedCountSubtle,
  ScanAgainContainer,
  SuccessfulControlTests,
  TestProcedureEvidenceSourcesContainer,
  UserEditedControlTestContainer,
  UserEditedControlTestIcon,
  UserEditedControlTestLightIcon,
  EditedResultSection,
  ControlCheckSummaryTitle,
  ControlCheckSourceResultMismatchContainer,
  ControlCheckSourceResultMismatchRow,
  ControlGapRemediationContainer,
  ControlRemediationIcon,
  ControlGapRemediationItem,
  ReasonResultsEditedTitle,
  EditReviewInfoText,
  EditReviewTooltipBody,
  CopyMenuDropdown,
  CopyMenuItem,
  EditReviewInfoContainer,
  FadeIn,
} from './AuditBotControlChecks.styles'
import {
  useControlPolicyMatchDetails,
  useOperatingEffectivenessDetails,
} from './AuditBotControlChecks.hooks'
import {
  ControlCheckProvider,
  useControlCheckContext,
} from './context/AuditBotControlCheckContext'

export const formatEditInfoText = (check: ControlTest): string => {
  const testName = getControlTestName(check.getTestName())
  const from = check.getOriginalResult() ? 'passing' : 'failure'
  const to = check.getResult() === AUDIT_RESULT.PASS ? 'passing' : 'failure'
  const editedAt = check.getEditedAt()
  if (!editedAt)
    return `The ${testName} result was edited from ${from} to ${to}.`
  const date = dayjs(editedAt).format(DATE_FORMATS.ISO)
  const time = dayjs(editedAt).format(DATE_FORMATS.TIME_ONLY_12H)
  return `The ${testName} result was edited from ${from} to ${to} by ${check.getEditedBy()} on ${date} at ${time}.`
}

export const formatReviewInfoText = (check: ControlTest): string => {
  const testName = getControlTestName(check.getTestName())
  const date = dayjs(check.getReviewedAt()).format(DATE_FORMATS.ISO)
  const time = dayjs(check.getReviewedAt()).format(DATE_FORMATS.TIME_ONLY_12H)
  return `The ${testName} result was reviewed by ${check.getReviewedBy()} on ${date} at ${time}.`
}

/** Header pills for a control's tests; suffix must be unique when multiple accordions share a control id. */
export const controlTestsAccordionHeaderNotes = (
  tooltipIdSuffix: string,
  controlChecks: ControlTest[],
): string | JSX.Element | undefined => {
  const hasEditedTestDetails = IsGatekeeperEnabled(
    GatekeeperFlag.SHOW_EDITED_TEST_DETAILS,
  )
  const editedTests = controlChecks.filter(
    (ct) => ct.getReasonSource() === REASON_SOURCE.USER,
  )
  const anyEdited = editedTests.length > 0
  const reviewedTests = controlChecks.filter((ct) => ct.getReviewedAt() > 0)
  const reviewedCount = reviewedTests.length
  const totalCount = controlChecks.length
  if (!hasEditedTestDetails || (!anyEdited && reviewedCount === 0)) {
    return ''
  }
  return (
    <FlexRow gap={8} justify={FlexAlign.FLEX_END}>
      {anyEdited && (
        <Tooltip
          id={`control-edit-tooltip-${tooltipIdSuffix}`}
          tooltipBody={
            <EditReviewTooltipBody>
              {editedTests.map((ct, i) => (
                <div key={ct.getId() || i}>{formatEditInfoText(ct)}</div>
              ))}
            </EditReviewTooltipBody>
          }
          placement="top"
        >
          <span>
            <Pill
              label="Results edited"
              backgroundColor="#FFFFFF"
              useBorder
              $size="small"
            />
          </span>
        </Tooltip>
      )}
      {reviewedCount > 0 && (
        <Tooltip
          id={`control-review-tooltip-${tooltipIdSuffix}`}
          tooltipBody={
            <EditReviewTooltipBody>
              {reviewedTests.map((ct, i) => (
                <div key={ct.getId() || i}>{formatReviewInfoText(ct)}</div>
              ))}
            </EditReviewTooltipBody>
          }
          placement="top"
        >
          <span>
            <Pill
              label={
                <>
                  Reviewed,
                  <ReviewedCountSubtle>
                    {reviewedCount} of {totalCount}
                  </ReviewedCountSubtle>
                </>
              }
              backgroundColor="#FFFFFF"
              useBorder
              $size="small"
            />
          </span>
        </Tooltip>
      )}
    </FlexRow>
  )
}

export const ScanAgainIcon = (): JSX.Element => (
  <SmallStyledSubsectionAccordionIcon icon={faRefresh} />
)

export const ControlCheckOtherResult = ({
  result,
}: {
  result: AUDIT_RESULT
}): JSX.Element => {
  const icon = getControlCheckOtherIcon(result)
  const reason = getControlCheckOtherReason(result)

  return (
    <DocumentsReadyCheckContainer>
      <DocumentsReadyCheckHeader>
        {icon}
        {reason}
      </DocumentsReadyCheckHeader>
    </DocumentsReadyCheckContainer>
  )
}

const UserEditedControlTest = ({
  isHoverState,
}: {
  isHoverState?: boolean
}): JSX.Element => (
  <UserEditedControlTestContainer $backgroundColorDark={isHoverState}>
    {isHoverState ? (
      <UserEditedControlTestLightIcon />
    ) : (
      <UserEditedControlTestIcon />
    )}
  </UserEditedControlTestContainer>
)

const ControlCheckIcon = ({
  controlTest,
  isHover,
}: {
  controlTest: ControlTest
  isHover: boolean
}) => {
  const hasPermission = useCanPerformAction(CAPABILITY.CAN_UPDATE_AUDIT_SCANS)
  const { openModal } = useModalState()
  const { setCurrentControlTest } = useCurrentControlTestContext()

  const handleClick = () => {
    if (!hasPermission) {
      return
    }
    // setCurrentControlTestStateInContext
    setCurrentControlTest(controlTest)
    // open modal
    openModal(ModalFormId.EDIT_AUDITBOT_RESULT)
  }

  const isUserEdited = controlTest.getReasonSource()
  const isNotPass =
    controlTest.getResult() === AUDIT_RESULT.FAIL ||
    controlTest.getResult() === AUDIT_RESULT.LAMBDA_ERROR ||
    controlTest.getResult() === AUDIT_RESULT.UNKNOWN

  return (
    <div onClick={handleClick}>
      {isHover && hasPermission ? (
        <UserEditedControlTest isHoverState={isHover} />
      ) : isUserEdited ? (
        <UserEditedControlTest />
      ) : isNotPass ? (
        <ControlCheckEroConcernedIcon />
      ) : (
        <ControlCheckEroIcon />
      )}
    </div>
  )
}

export const ControlCheckDateLink = ({
  updatedAt,
  auditRunId,
}: {
  updatedAt: number
  auditRunId: string
}): JSX.Element => {
  const { pageContext } = useParams()
  const date = formatTimestampFromNumber(updatedAt, DATE_FORMATS.WITH_TIME)

  return (
    <>
      <ControlCheckDateContainer>{date}</ControlCheckDateContainer>
      <a
        href={`/${pageContext}/${ExamineAndTestAbsoluteRoutes.SHOW}/${auditRunId}`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => e.stopPropagation()}
      >
        <LinkIcon />
      </a>
    </>
  )
}

export const ControlCheckSourceTitle = ({
  source,
  onClick,
  result,
  isPolicySource,
  showPassFail,
}: {
  source: Source
  onClick: (pageNumber?: number) => void
  result: SOURCE_RESULT
  isPolicySource?: boolean
  showPassFail?: boolean
}): JSX.Element => {
  const caption = source.getName()
  const docSourceInfo = source.getDocumentSourceInfo()
  const relevantDate = docSourceInfo?.getRelevantDate()
  const isDeleted = docSourceInfo?.getIsDeleted()
  const resultIcon = getOESourceResultIcon(result)

  const pageNumbers = useMemo(() => {
    const pageNumbersList =
      docSourceInfo
        ?.getPageNumbersList()
        ?.filter((pageNumber) => pageNumber !== 0) ?? []
    return pageNumbersList.map((pageNumber) => ({
      pageNumber,
      onClick: () => onClick(pageNumber),
    }))
  }, [docSourceInfo, onClick])

  return (
    <FlexRow gap={8} justify={FlexAlign.FLEX_START}>
      {isPolicySource && <DocumentSourcePolicyIcon />}
      {showPassFail && resultIcon}
      <span>{caption}</span>
      <DocumentSourceRelevantDate>
        {relevantDate &&
          formatTimestamp(relevantDate, DATE_FORMATS.ISO_WITH_TIME)}
      </DocumentSourceRelevantDate>
      {isDeleted ? (
        <SourceDeleted>(Deleted)</SourceDeleted>
      ) : (
        <CitationLink
          citationType={{
            onClick: () => {
              onClick()
            },
            pageNumbers,
          }}
          mimeType={docSourceInfo?.getMime()}
        />
      )}
    </FlexRow>
  )
}

export const ControlCheckSourceResultMismatch = (): JSX.Element => {
  const hasPermissionToEdit = useCanPerformAction(
    CAPABILITY.CAN_UPDATE_AUDIT_SCANS,
  )
  const { controlCheck } = useControlCheckContext()
  const { setCurrentControlTest } = useCurrentControlTestContext()
  const { openModal } = useModalState()
  const canEdit = hasPermissionToEdit && !!controlCheck

  const handleEdit = () => {
    setCurrentControlTest(controlCheck)
    openModal(ModalFormId.EDIT_AUDITBOT_RESULT)
  }
  return (
    <ControlCheckSourceResultMismatchRow justify={FlexAlign.SPACE_BETWEEN}>
      <ControlCheckSourceResultMismatchContainer>
        <InfoSVG />
        Test result and evidence result disagree.
        <LearnMoreLink
          href="https://support.trustero.com/knowledge/why-are-my-evidence-and-test"
          onClick={(e) => e.stopPropagation()}
        />
      </ControlCheckSourceResultMismatchContainer>
      <FlexRow gap={8}>
        {canEdit && (
          <>
            <EditSVG />
            <TextButton onClick={handleEdit}>Edit Result</TextButton>
          </>
        )}
      </FlexRow>
    </ControlCheckSourceResultMismatchRow>
  )
}

export const ControlCheckSourceComponent = ({
  source,
  isPolicySource,
  isOperatingEffectiveness,
  overallResult,
}: {
  source: Source
  isPolicySource?: boolean
  isOperatingEffectiveness?: boolean
  overallResult?: SOURCE_RESULT
}): JSX.Element => {
  const hasTestTable = IsGatekeeperEnabled(GatekeeperFlag.TEST_TABLE)
  const { pageContext } = useParams()
  const location = useLocation()
  const { setCurrentDocumentSource } = useDocumentSourceContext()
  const { openModal } = useModalState()

  const testTable = source.getTestTable()
  const docSourceInfo = source.getDocumentSourceInfo()
  const isAutomated = docSourceInfo?.getIsAutomated()
  const showTestTable = hasTestTable && testTable
  const summary = showTestTable ? testTable.getSummary() : source.getSummary()
  const testTableExplanation = source.getTestTableExplanation()
  const testTableNotGenerated = hasTestTable && isAutomated && !testTable
  const displayExplanation = getTestTableExplanationText(testTableExplanation)
  const result = showTestTable ? testTable.getResult() : source.getResult()
  const showMismatch = result === SOURCE_RESULT.FAIL && result !== overallResult

  const viewDocSource = useCallback(
    (pageNumber?: number) => {
      const link = getControlCheckSourceLink(
        pageContext as string,
        location.search,
        source,
        pageNumber,
      )
      openInNewTab(link)
    },
    [pageContext, location.search, source],
  )

  const viewTestTable = () => {
    setCurrentDocumentSource(source)
    openModal(ModalFormId.VIEW_TEST_TABLE_SOURCE)
  }

  return (
    <SourceContainer>
      <ControlCheckSourceTitle
        source={source}
        onClick={viewDocSource}
        result={result}
        isPolicySource={isPolicySource}
        showPassFail={isOperatingEffectiveness}
      />
      <SourceSummary $isItalic>{summary}</SourceSummary>
      {testTableNotGenerated && (
        <SourceSummary $isItalic $isExplanation>
          {displayExplanation}
        </SourceSummary>
      )}
      {showTestTable && (
        <ControlCheckSourceTestTableButton>
          <TextButton
            requiredCapabilities={[CAPABILITY.CAN_VIEW_AUDIT_SCANS]}
            onClick={viewTestTable}
          >
            View Test Table
          </TextButton>
        </ControlCheckSourceTestTableButton>
      )}
      {showMismatch && <ControlCheckSourceResultMismatch />}
    </SourceContainer>
  )
}

export const ControlCheckTestProcedure = ({
  orderNumber,
  testProcedure,
  total,
}: {
  orderNumber: number
  testProcedure: OETestProcedureResult
  total: number
}): JSX.Element => {
  const description = cleanTestProcedureDescription(
    testProcedure.getDescription(),
  )
  const summary = testProcedure.getSummary()
  const evidenceResults = testProcedure.getEvidenceResultsList()
  const isFail = testProcedure.getResult() !== SOURCE_RESULT.PASS
  const tpResult = testProcedure.getResult()
  const tpIcon = getOESourceResultIcon(tpResult)
  const showNumber = total > 1

  return (
    <ControlCheckTestProcedureContainer $isFail={isFail}>
      <ControlCheckTestProcedureIcon>{tpIcon}</ControlCheckTestProcedureIcon>
      {showNumber && (
        <ControlCheckTestProcedureNumber>
          {orderNumber}.
        </ControlCheckTestProcedureNumber>
      )}
      <ControlCheckTestProcedureDescription $showNumber={showNumber}>
        <ControlCheckMarkup markdown={description} />
      </ControlCheckTestProcedureDescription>
      <ControlCheckTestProcedureBody $showNumber={showNumber}>
        <ControlCheckMarkup
          markdown={summary}
          sectionProps={{ fontStyle: 'italic' }}
        />
        {evidenceResults.length > 0 && (
          <TestProcedureEvidenceSourcesContainer>
            Evidence and Sources
            {evidenceResults.map((evidenceResult, index) => (
              <ControlCheckSourceComponent
                key={index}
                source={evidenceResult}
                isOperatingEffectiveness
                overallResult={tpResult}
              />
            ))}
          </TestProcedureEvidenceSourcesContainer>
        )}
      </ControlCheckTestProcedureBody>
    </ControlCheckTestProcedureContainer>
  )
}

export const ControlPolicyMatchSource = ({
  cpmdSource,
  isLoading,
}: {
  cpmdSource: Source
  isLoading: boolean
}): JSX.Element =>
  isLoading ? (
    <TableListLoader />
  ) : (
    <ControlCheckSourcesContainer>
      <ControlCheckSourceComponent source={cpmdSource} isPolicySource />
    </ControlCheckSourcesContainer>
  )

export const OperatingEffectivenessSources = ({
  oeSources,
  isLoading,
}: {
  oeSources: OETestProcedureResult[]
  isLoading: boolean
}): JSX.Element | null =>
  isLoading ? (
    <TableListLoader />
  ) : oeSources.length > 0 ? (
    <>
      <ControlCheckSourcesContainer>
        <SectionTitle $size={14} $mb={8}>
          TEST DETAILS
        </SectionTitle>
        {oeSources.map((testProcedure, index) => (
          <ControlCheckTestProcedure
            key={index}
            orderNumber={index + 1}
            testProcedure={testProcedure}
            total={oeSources.length}
          />
        ))}
      </ControlCheckSourcesContainer>
    </>
  ) : null

export const ControlCheckResultBody = ({
  check,
  testName,
  resultIcon,
  displayReason,
  showDateLink,
  isHover = false,
}: {
  check: ControlTest
  testName: string
  resultIcon: JSX.Element
  displayReason: string
  showDateLink?: boolean
  isHover?: boolean
}): JSX.Element => {
  return (
    <>
      <DocumentsReadyCheckHeader>
        {resultIcon}
        {getControlTestName(testName)}
        {showDateLink && (
          <ControlCheckDateLink
            updatedAt={check.getUpdatedAt()}
            auditRunId={check.getAuditRunId()}
          />
        )}
      </DocumentsReadyCheckHeader>
      <ControlCheckPassBody>
        {PASSED_CONTROL_CHECK_TEXT[`${testName}` as CONTROL_TEST_NAMES]}
        <ControlCheckEroText $isItalic={!check.getReasonSource()}>
          <>
            <ControlCheckIcon isHover={isHover} controlTest={check} />
            <Markup markdown={displayReason} isEvidence />
          </>
        </ControlCheckEroText>
      </ControlCheckPassBody>
    </>
  )
}

export const ControlCheckCopyMenu = ({
  checkId,
  displayReason,
  oeSources,
  cpmdSources,
  controlCheck,
  oeArtifactReasoning,
  oeArtifactSources,
}: {
  checkId: string
  displayReason: string
  oeSources?: OETestProcedureResult[]
  cpmdSources?: Source[]
  controlCheck?: ControlTest
  oeArtifactReasoning?: string
  oeArtifactSources?: OeControlTestResult[]
}): JSX.Element => {
  const onClickTimeoutRef = useRef(0)
  const [show, setShow] = useState<boolean>(false)
  const hasEditedTestDetails = IsGatekeeperEnabled(
    GatekeeperFlag.SHOW_EDITED_TEST_DETAILS,
  )

  const showToolTip = () => {
    setShow(true)
    onClickTimeoutRef.current = window.setTimeout(() => {
      setShow(false)
    }, 500)
  }

  const isUserEdited = controlCheck?.getReasonSource() === REASON_SOURCE.USER
  const originalReason =
    controlCheck?.getOriginalReason?.() || oeArtifactReasoning || ''
  const isAdvancedOe = !!oeArtifactSources?.length

  const getHeaderText = (): string => {
    if (!controlCheck) return ''
    const result = controlCheck.getResult()
    const icon = result === AUDIT_RESULT.PASS ? '✓' : '✗'
    const testName = controlCheck.getTestName()
    const testLabel = `${getControlTestName(testName)} Result${
      isAdvancedOe ? ' (Advanced)' : ''
    }`
    const controlModelId = controlCheck.getControlModelId()
    const controlName = controlCheck.getControlName()
    return `${icon} ${testLabel} for ${controlModelId} ${controlName}`
  }

  const getSummaryText = (): string => {
    const header = getHeaderText()
    const headerLine = header ? `${header}\n\n` : ''
    if (hasEditedTestDetails && isUserEdited && originalReason) {
      return `${headerLine}Reason Results Edited:\n${displayReason}\n\nSummary:\n${originalReason}`
    }
    return `${headerLine}${displayReason}`
  }

  const getArtifactSourcesText = (): string => {
    if (!oeArtifactSources?.length) return ''
    return oeArtifactSources
      .map((source, index) => {
        const isPassing =
          source.getDetermination() === OeControlTestDetermination.PASS
        const icon = isPassing ? '✓' : '✗'
        const testString = source.getTestString()
        const reasoning = source.getReasoning()
        const citations = source.getCitationsList()

        let text = `${icon} ${index + 1}. ${testString}\n${reasoning}`

        if (citations.length) {
          const citationText = citations
            .map((citation) => {
              const isContext = citation.getCitationType() === 3
              const title = isContext
                ? 'Organizational Context'
                : citation.getEvidenceCaption()
              const relevantDate = citation.getRelevantDate()
              const formattedDate = relevantDate
                ? dayjs(relevantDate).format(DATE_FORMATS.ISO_WITH_TIME)
                : ''
              const findingSummary = citation.getFindingSummary()

              const parts = [
                formattedDate ? `${title}  ${formattedDate}` : title,
              ]
              if (findingSummary) parts.push(findingSummary)
              return parts.join('\n')
            })
            .join('\n\n')
          text += `\n\nEvidence and Sources:\n${citationText}`
        }

        return text
      })
      .join('\n\n')
  }

  const getDetailText = (): string => {
    let details = ''
    if (oeSources) {
      details = getOperatingEffectivenessDetailText('', oeSources)
    } else if (oeArtifactSources?.length) {
      details = getArtifactSourcesText()
    } else if (cpmdSources?.length) {
      details = getControlPolicyMatchDetailText('', cpmdSources)
    }
    return details
      ? `${getSummaryText()}\n\n${details.trimStart()}`
      : getSummaryText()
  }

  const copySummary = async () => {
    await navigator.clipboard.writeText(getSummaryText())
    showToolTip()
  }

  const copySummaryAndDetails = async () => {
    await navigator.clipboard.writeText(getDetailText())
    showToolTip()
  }

  const copyAnswerFunc = async () => {
    await navigator.clipboard.writeText(displayReason)
    showToolTip()
  }
  const copyAnswerWithCpmdSource = async () => {
    if (!cpmdSources?.length) return
    const allText = getControlPolicyMatchDetailText(displayReason, cpmdSources)
    navigator.clipboard.writeText(allText)
    showToolTip()
  }

  const copyAnswerWithOeSources = async () => {
    if (!oeSources) return
    const allText = getOperatingEffectivenessDetailText(
      displayReason,
      oeSources,
    )
    navigator.clipboard.writeText(allText)
    showToolTip()
  }

  const hasSources = !!(
    oeSources ||
    oeArtifactSources?.length ||
    cpmdSources?.length
  )

  return (
    <ControlCheckCopyMenuDropdown>
      <Tooltip
        id={`control-check-copy-tooltip-${checkId}`}
        trigger={['hover', 'click']}
        show={show}
        placement="top"
        tooltipBody={'Copied!'}
      >
        <Dropdown id={`control-check-copy-menu-${checkId}`}>
          <Dropdown.Toggle as={SimpleIconButton}>
            <ControlCheckCopyIcon />
          </Dropdown.Toggle>
          {hasEditedTestDetails ? (
            <Dropdown.Menu as={CopyMenuDropdown} rootCloseEvent="mousedown">
              <Dropdown.Item as={CopyMenuItem} onClick={copySummary}>
                Copy summary
              </Dropdown.Item>
              {hasSources && (
                <Dropdown.Item
                  as={CopyMenuItem}
                  onClick={copySummaryAndDetails}
                >
                  Copy summary &amp; test details
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          ) : (
            <Dropdown.Menu>
              <Dropdown.Item as="button" onClick={copyAnswerFunc}>
                Copy Answer
              </Dropdown.Item>
              {!!cpmdSources?.length && (
                <Dropdown.Item as="button" onClick={copyAnswerWithCpmdSource}>
                  Copy All
                </Dropdown.Item>
              )}
              {oeSources && (
                <Dropdown.Item as="button" onClick={copyAnswerWithOeSources}>
                  Copy All
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          )}
        </Dropdown>
      </Tooltip>
    </ControlCheckCopyMenuDropdown>
  )
}

export const ControlCheckButtons = ({
  controlCheck,
  displayReason,
  oeSources,
  cpmdSources,
  oeArtifactReasoning,
  oeArtifactSources,
  isVisible = true,
  allowMarkCurrent = true,
}: {
  controlCheck: ControlTest
  displayReason: string
  oeSources?: OETestProcedureResult[]
  cpmdSources?: Source[]
  oeArtifactReasoning?: string
  oeArtifactSources?: OeControlTestResult[]
  isVisible?: boolean
  allowMarkCurrent?: boolean
}): JSX.Element => {
  const hasPermissionToEdit = useCanPerformAction(
    CAPABILITY.CAN_UPDATE_AUDIT_SCANS,
  )
  const canReview = useCanPerformAction(CAPABILITY.CAN_REVIEW_AUDIT_SCANS)
  const reviewControlTest = useReviewControlTestResult()
  const { openModal } = useModalState()
  const { setCurrentControlTest } = useCurrentControlTestContext()

  const handleEdit = () => {
    setCurrentControlTest(controlCheck)
    openModal(ModalFormId.EDIT_AUDITBOT_RESULT)
  }

  const isUserEdited = controlCheck.getReasonSource() === REASON_SOURCE.USER
  const hasEditedTestDetails = IsGatekeeperEnabled(
    GatekeeperFlag.SHOW_EDITED_TEST_DETAILS,
  )
  const isReviewed = controlCheck.getReviewedAt() > 0

  const handleToggleReviewed = (e: React.MouseEvent) => {
    e.stopPropagation()
    reviewControlTest(controlCheck.getId(), isReviewed)
  }

  return (
    <ControlCheckButtonGroup $isVisible={isVisible}>
      {isUserEdited && !hasEditedTestDetails && (
        <EditedResultSection>Edited</EditedResultSection>
      )}
      {hasEditedTestDetails && canReview && (
        <MarkAsReviewedButton type="button" onClick={handleToggleReviewed}>
          {isReviewed ? 'MARK AS PENDING REVIEW' : 'MARK AS REVIEWED'}
        </MarkAsReviewedButton>
      )}
      {allowMarkCurrent && (
        <MarkControlTestCurrentButton
          controlTestId={controlCheck.getId()}
          isStale={controlCheck.getIsStale()}
        />
      )}
      {hasPermissionToEdit && (
        <SimpleIconButton onClick={handleEdit}>
          <ControlCheckEditIcon />
        </SimpleIconButton>
      )}
      <ControlCheckCopyMenu
        checkId={controlCheck.getId()}
        displayReason={displayReason}
        oeSources={oeSources}
        cpmdSources={cpmdSources}
        controlCheck={controlCheck}
        oeArtifactReasoning={oeArtifactReasoning}
        oeArtifactSources={oeArtifactSources}
      />
    </ControlCheckButtonGroup>
  )
}

export const ControlCheckResult = ({
  check,
  accordionId,
  showTyping,
  showDateLink,
  handleClick,
  getIsExpanded,
  allowMarkCurrent = true,
}: {
  check: ControlTest
  accordionId: string
  showTyping?: boolean
  showDateLink?: boolean
  handleClick: (e: React.MouseEvent, eventKey: string) => void
  getIsExpanded: (eventKey: string) => boolean
  allowMarkCurrent?: boolean
}): JSX.Element => {
  const hasCiteSources = IsGatekeeperEnabled(GatekeeperFlag.CITE_SOURCES)
  const hasEditedTestDetails = IsGatekeeperEnabled(
    GatekeeperFlag.SHOW_EDITED_TEST_DETAILS,
  )
  const [isHover, setIsHover] = useState<boolean>(false)
  const { setControlCheck } = useControlCheckContext()

  useEffect(() => {
    setControlCheck(check)
  }, [check, setControlCheck])

  const checkId = check.getId()
  // Stable accordion event key (not the ControlTest row id), so a live OE
  // accordion and this eventual completed row share one key — expansion survives
  // the swap. Also the key the live OeLiveTestAccordionItem uses.
  const accordionKey = getControlCheckAccordionKey(
    accordionId,
    check.getTestName(),
  )
  const isControlPolicyMaterialDifference =
    check.getTestName() === CONTROL_TEST_NAMES.POLICY_MATCH
  const isOperatingEffectiveness =
    check.getTestName() === CONTROL_TEST_NAMES.SPOT_CHECK
  const isExpanded = useMemo(
    () => getIsExpanded(accordionKey),
    [getIsExpanded, accordionKey],
  )
  const artifactId = check.getArtifactId()
  const isUserEdited = check.getReasonSource() === REASON_SOURCE.USER
  const isReviewed = check.getReviewedAt() > 0
  const shouldHideSources = isUserEdited && !hasEditedTestDetails
  const fetchOeSources =
    isOperatingEffectiveness && isExpanded && !shouldHideSources
  const fetchOeArtifact = fetchOeSources && !!artifactId
  const fetchOeSourcesDb = fetchOeSources && !fetchOeArtifact
  const fetchCpmdSources =
    isControlPolicyMaterialDifference && isExpanded && !shouldHideSources
  const {
    data: oeData,
    isLoading: oeLoading,
    error: oeError,
  } = useOperatingEffectivenessDetails(checkId, fetchOeSourcesDb)
  const {
    data: oeArtifactData,
    isLoading: oeArtifactLoading,
    error: oeArtifactError,
  } = useArtifact(artifactId)
  const {
    data: cpmdData,
    isLoading: cpmdLoading,
    error: cpmdError,
  } = useControlPolicyMatchDetails(checkId, fetchCpmdSources)
  const error = useMemo(
    () => oeError || cpmdError || oeArtifactError,
    [oeError, cpmdError, oeArtifactError],
  )
  const resultIcon = getCheckResultIcon(
    check.getResult(),
    CHECK_RESULT_TYPE.INDIVIDUAL,
  )
  const reasonText = check.getReason()
  const testName = check.getTestName()
  const testNameText = `${getControlTestName(testName)} Result${
    oeArtifactData ? ' (Advanced)' : ''
  }`
  const reason =
    CONTROL_CHECK_ERROR_MAP[reasonText as CONTROL_CHECK_ERRORS] || reasonText

  const typedReason = useTypewriter({ text: reason, shouldType: showTyping })

  // Full reason for copy/details; a separately-typed value drives the SUMMARY
  // display so it types in on a fresh scan (showTyping) without the copy menu
  // ever grabbing a half-typed string.
  const displayReason = reason
  const displayedReason = showTyping ? typedReason : reason

  if (error) {
    log.error(`Error fetching sources for check id ${checkId}`, error)
  }

  const oeSources = oeData?.getTestProcedureResultsList()
  const oeControlResultsArtifact = oeArtifactData
    ?.getArtifact()
    ?.getOeControlResultsArtifact()
  const oeArtifactSources =
    oeControlResultsArtifact?.getOeControlTestCitationsList()
  const cpmdDataWithList = cpmdData as
    | (typeof cpmdData & { getSourcesList?: () => Source[] })
    | undefined
  const cpmdSourceList = cpmdDataWithList?.getSourcesList?.() ?? []
  const cpmdSources = cpmdSourceList.length
    ? cpmdSourceList
    : cpmdData?.getSourceDetails()
    ? [cpmdData.getSourceDetails() as Source]
    : []

  if (HIDE_CONTROL_CHECK_REASON_MAP[reasonText as HIDE_CONTROL_CHECK_REASONS]) {
    return <></>
  }

  return hasCiteSources ? (
    <DocumentsReadyCheckContainer
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <ControlCheckTestAccordionItem eventKey={accordionKey} $hoverable>
        <ControlCheckTestAccordionHeader
          $isActive={isExpanded}
          onClick={(e: React.MouseEvent) => handleClick(e, accordionKey)}
        >
          <DocumentsReadyCheckHeader
            style={hasEditedTestDetails ? { width: '100%' } : undefined}
          >
            {resultIcon}
            {testNameText}
            {showDateLink && (
              <ControlCheckDateLink
                updatedAt={check.getUpdatedAt()}
                auditRunId={check.getAuditRunId()}
              />
            )}
            <DropdownSVG className="control-check-chevron" />
            {hasEditedTestDetails && isUserEdited && (
              <Tooltip
                id={`edit-tooltip-${checkId}`}
                tooltipBody={
                  <EditReviewTooltipBody>
                    {formatEditInfoText(check)}
                  </EditReviewTooltipBody>
                }
                placement="top"
              >
                <span>
                  <Pill
                    label="Results edited"
                    backgroundColor={palette.neutral.white}
                    useBorder
                    $size="small"
                  />
                </span>
              </Tooltip>
            )}
            {hasEditedTestDetails && isReviewed && (
              <Tooltip
                id={`review-tooltip-${checkId}`}
                tooltipBody={
                  <EditReviewTooltipBody>
                    {formatReviewInfoText(check)}
                  </EditReviewTooltipBody>
                }
                placement="top"
              >
                <span>
                  <Pill
                    label="Reviewed"
                    backgroundColor={palette.neutral.white}
                    useBorder
                    $size="small"
                  />
                </span>
              </Tooltip>
            )}
            {hasEditedTestDetails && (
              <ControlCheckHeaderButtonsWrapper
                onClick={(e) => e.stopPropagation()}
              >
                <ControlCheckButtons
                  controlCheck={check}
                  displayReason={displayReason}
                  oeSources={oeSources}
                  cpmdSources={cpmdSources}
                  oeArtifactReasoning={oeControlResultsArtifact?.getReasoning()}
                  oeArtifactSources={oeArtifactSources}
                  isVisible={isHover && isExpanded}
                  allowMarkCurrent={allowMarkCurrent}
                />
              </ControlCheckHeaderButtonsWrapper>
            )}
          </DocumentsReadyCheckHeader>
        </ControlCheckTestAccordionHeader>
        <ControlCheckTestAccordionBody>
          <ControlCheckResultContainer>
            <ControlCheckDescriptionRow>
              {PASSED_CONTROL_CHECK_TEXT[`${testName}` as CONTROL_TEST_NAMES]}
              {!hasEditedTestDetails && (
                <ControlCheckButtons
                  controlCheck={check}
                  displayReason={displayReason}
                  oeSources={oeSources}
                  cpmdSources={cpmdSources}
                  oeArtifactReasoning={oeControlResultsArtifact?.getReasoning()}
                  oeArtifactSources={oeArtifactSources}
                  isVisible={isHover && isExpanded}
                  allowMarkCurrent={allowMarkCurrent}
                />
              )}
            </ControlCheckDescriptionRow>
            {hasEditedTestDetails && (isUserEdited || isReviewed) && (
              <EditReviewInfoContainer>
                {isUserEdited && (
                  <EditReviewInfoText>
                    {formatEditInfoText(check)}
                  </EditReviewInfoText>
                )}
                {isReviewed && (
                  <EditReviewInfoText>
                    {formatReviewInfoText(check)}
                  </EditReviewInfoText>
                )}
              </EditReviewInfoContainer>
            )}
            {hasEditedTestDetails && isUserEdited && (
              <>
                <ReasonResultsEditedTitle>
                  REASON RESULTS EDITED
                </ReasonResultsEditedTitle>
                <ControlCheckEroText $isItalic={false}>
                  <ControlCheckMarkup markdown={displayReason} />
                </ControlCheckEroText>
              </>
            )}
            {isOperatingEffectiveness && (
              <ControlCheckSummaryTitle>SUMMARY</ControlCheckSummaryTitle>
            )}
            <ControlCheckEroText
              $isItalic={
                hasEditedTestDetails && isUserEdited
                  ? true
                  : !check.getReasonSource()
              }
            >
              <ControlCheckMarkup
                markdown={
                  hasEditedTestDetails && isUserEdited
                    ? check.getOriginalReason() ||
                      oeControlResultsArtifact?.getReasoning() ||
                      displayReason
                    : displayedReason
                }
              />
            </ControlCheckEroText>
          </ControlCheckResultContainer>
          {!shouldHideSources && (
            <>
              {cpmdSources?.map((cpmdSource, index) => (
                <ControlPolicyMatchSource
                  key={`${cpmdSource.getId()}-${cpmdSource.getName()}-${index}`}
                  cpmdSource={cpmdSource}
                  isLoading={cpmdLoading}
                />
              ))}
              {oeSources && (
                <OperatingEffectivenessSources
                  oeSources={oeSources}
                  isLoading={oeLoading}
                />
              )}
              {oeArtifactSources && (
                <OperatingEffectivenessArtifactSources
                  oeSources={oeArtifactSources}
                  isLoading={oeArtifactLoading}
                />
              )}
            </>
          )}
        </ControlCheckTestAccordionBody>
      </ControlCheckTestAccordionItem>
    </DocumentsReadyCheckContainer>
  ) : (
    <DocumentsReadyCheckContainer
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <ControlCheckResultBody
        check={check}
        testName={testName}
        resultIcon={resultIcon}
        displayReason={displayReason}
        showDateLink={showDateLink}
        isHover={isHover}
      />
    </DocumentsReadyCheckContainer>
  )
}

export const ControlCheckResults = ({
  checks,
  controlId,
  accordionId = controlId,
  isNewRun,
  expandedChecks,
  setExpandedChecks,
  allowMarkCurrent = true,
}: {
  checks: ControlTest[]
  controlId: string
  // Stable id for accordion event keys; the run show page passes the model id
  // (invariant across the live→final swap), else it falls back to controlId.
  accordionId?: string
  isNewRun?: boolean
  expandedChecks: string[]
  setExpandedChecks?: React.Dispatch<React.SetStateAction<string[]>>
  allowMarkCurrent?: boolean
}): JSX.Element => {
  const artifactId = getControlOeArtifactId(checks)

  const handleAccordionClick = (e: React.MouseEvent, eventKey: string) => {
    e.preventDefault()
    e.stopPropagation()
    if (!setExpandedChecks) return
    let keys = [...expandedChecks]
    if (keys.includes(eventKey)) {
      keys = keys.filter((key) => key !== eventKey)
      return setExpandedChecks(keys)
    }
    return setExpandedChecks([...keys, eventKey])
  }

  const getIsExpanded = (eventKey: string) => {
    return expandedChecks.includes(eventKey)
  }

  return (
    <>
      {artifactId && (
        <ControlGapsAndRecommendations
          controlId={controlId}
          accordionId={accordionId}
          artifactId={artifactId}
          handleClick={handleAccordionClick}
          getIsExpanded={getIsExpanded}
          isNewRun={isNewRun}
        />
      )}
      {checks.map((check) => (
        <ControlCheckProvider key={`${check.getTestName()}-${controlId}`}>
          <ControlCheckResult
            check={check}
            accordionId={accordionId}
            showTyping={isNewRun}
            handleClick={handleAccordionClick}
            getIsExpanded={getIsExpanded}
            allowMarkCurrent={allowMarkCurrent}
          />
        </ControlCheckProvider>
      ))}
    </>
  )
}

export const ControlGapsAndRecommendations = ({
  controlId,
  accordionId = controlId,
  artifactId,
  handleClick,
  getIsExpanded,
  isNewRun = false,
}: {
  controlId: string
  // Stable id for the gaps accordion event key (model id on the run show page,
  // else controlId). controlId itself stays for data ops below.
  accordionId?: string
  artifactId: string
  handleClick: (e: React.MouseEvent, eventKey: string) => void
  getIsExpanded: (eventKey: string) => boolean
  // On a fresh scan, fade the gaps in as the control finalizes.
  isNewRun?: boolean
}): JSX.Element => {
  const { pageContext } = useParams()
  const canAddRequests = useCanPerformAction(CAPABILITY.CAN_ADD_REQUESTS)
  const gapsKey = `gaps-${accordionId}`

  const { data: controlData } = useControl(controlId)
  const { data: usersData } = useUsers()
  const controlOwnerEmail = controlData?.getOwnerEmail() ?? ''
  const controlOwnerId = useMemo(
    () =>
      usersData
        ?.getUsersList()
        .map((u) => u.toObject())
        .find((u) => u.email === controlOwnerEmail)?.id,
    [usersData, controlOwnerEmail],
  )

  const {
    data: artifactData,
    isLoading: artifactLoading,
    error: artifactError,
  } = useArtifact(artifactId || '')

  const isExpanded = useMemo(
    () => getIsExpanded(gapsKey),
    [getIsExpanded, gapsKey],
  )

  // Get test results that have gaps
  const testResultsWithGaps = useMemo(() => {
    const testResults =
      artifactData
        ?.getArtifact()
        ?.getOeControlResultsArtifact()
        ?.getOeControlTestCitationsList() || []
    return testResults.filter((test) => test.getGapsList().length > 0)
  }, [artifactData])

  const hasNoTestResultGaps = useMemo(() => {
    if (!testResultsWithGaps.length) {
      return true
    }
    if (
      testResultsWithGaps.every(
        (testResult) => testResult.getGapsList().length === 0,
      )
    ) {
      return true
    }
    const gaps = testResultsWithGaps.flatMap((testResult) =>
      testResult.getGapsList(),
    )
    if (
      gaps.every(
        (gap) =>
          gap.getRemediationsList().length === 0 || gap.getDescription() === '',
      )
    ) {
      return true
    }
    return false
  }, [testResultsWithGaps])

  const legacyGaps = useMemo(
    () =>
      artifactData
        ?.getArtifact()
        ?.getOeControlResultsArtifact()
        ?.getGapsList() || [],
    [artifactData],
  )

  const sourceValue = controlTestSource(artifactId)
  const sourceFilterRequest = useMemo(() => {
    const req = new ListDocumentRequestsRequest()
    req.setSourceFilter(new StringValue().setValue(sourceValue))
    return req
  }, [sourceValue])

  const { data: existingRequestsData } = useDocumentRequests({
    request: sourceFilterRequest,
    shouldFetch: !!artifactId,
  })
  const hasExistingRequests =
    (existingRequestsData?.getItemsList().length ?? 0) > 0

  const requestsIndexUrl = `/${pageContext}/${
    RequestsAbsoluteRoutes.INDEX
  }?created_source=${encodeURIComponent(sourceValue)}`

  const { createRequests, isCreating } = useBulkCreateRequestsFromOeArtifact(
    controlId,
    controlData?.getModelId() ?? controlId,
    artifactId,
    testResultsWithGaps,
    controlOwnerId,
    legacyGaps.length > 0 && hasNoTestResultGaps ? legacyGaps : undefined,
  )

  const handleAddRequest = useCallback(
    async (e: React.MouseEvent) => {
      e.stopPropagation()
      try {
        await createRequests()
        openInNewTab(window.location.origin + requestsIndexUrl)
      } catch {
        showInfoToast(ToastPrompts.ADD_REQUEST_ERROR)
      }
    },
    [createRequests, requestsIndexUrl],
  )

  if (hasNoTestResultGaps && !legacyGaps.length) {
    if (artifactError) {
      log.error('Error fetching artifact', artifactError)
    }
    return <></>
  }

  const showLegacyGaps = legacyGaps.length > 0 && hasNoTestResultGaps

  const gapsBody = showLegacyGaps
    ? legacyGaps.map((gap, index) => (
        <ControlGapsAndRecommendationsItem key={index} gap={gap} />
      ))
    : testResultsWithGaps.map((testResult, index) => (
        <ControlTestGapsSection key={index} testResult={testResult} />
      ))

  const gapsItem = (
    <ControlCheckTestAccordionItem eventKey={gapsKey}>
      <ControlCheckTestAccordionHeader
        $isActive={isExpanded}
        onClick={(e: React.MouseEvent) => handleClick(e, gapsKey)}
      >
        <DocumentsReadyCheckHeader style={{ width: '100%' }}>
          <ErrorSVG width={18} height={18} />
          Gaps and Recommendations
          <DropdownSVG className="control-check-chevron" />
          {canAddRequests &&
            (isCreating ? (
              <Spinner color="primary" size="s" ml="auto" />
            ) : hasExistingRequests ? (
              <MappingsSectionCTA
                as={Link}
                to={requestsIndexUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{ marginLeft: 'auto', marginBottom: 0 }}
                onClick={(e: React.MouseEvent) => e.stopPropagation()}
              >
                VIEW REQUESTS
              </MappingsSectionCTA>
            ) : (
              <Tooltip
                id={`add-request-gaps-${controlId}`}
                tooltipBody="Create requests to follow up on Gaps and Recommendations"
                placement="top"
              >
                <MappingsSectionCTA
                  style={{ marginLeft: 'auto', marginBottom: 0 }}
                  onClick={handleAddRequest}
                >
                  ADD REQUEST
                </MappingsSectionCTA>
              </Tooltip>
            ))}
        </DocumentsReadyCheckHeader>
      </ControlCheckTestAccordionHeader>
      <ControlCheckTestAccordionBody>{gapsBody}</ControlCheckTestAccordionBody>
    </ControlCheckTestAccordionItem>
  )

  // Fade the whole section in as it appears on a fresh scan (it's collapsed by
  // default now). GapAccordion has no direct-child CSS, so the wrapper is safe.
  return artifactLoading ? (
    <TableListLoader />
  ) : isNewRun ? (
    <FadeIn>{gapsItem}</FadeIn>
  ) : (
    gapsItem
  )
}

export const ControlTestGapsSection = ({
  testResult,
}: {
  testResult: OeControlTestResult
}): JSX.Element => {
  const testName = getOeTestTitle(testResult.getTestString())
  const gaps = testResult.getGapsList()

  return (
    <div style={{ marginBottom: '16px' }}>
      <ControlCheckSummaryTitle style={{ marginBottom: '8px' }}>
        {testName}
      </ControlCheckSummaryTitle>
      {gaps.map((gap, index) => (
        <ControlTestGapItem key={index} gap={gap} />
      ))}
    </div>
  )
}

export const RemediationsList = ({
  remediations,
}: {
  remediations: string[]
}): JSX.Element => (
  <ul style={{ margin: 0, paddingLeft: 20 }}>
    {remediations.map((remediation, index) => (
      <li key={index}>{remediation}</li>
    ))}
  </ul>
)

export const ControlTestGapItem = ({
  gap,
}: {
  gap: OeControlTestGaps
}): JSX.Element => (
  <ControlGapRemediationContainer>
    <ControlGapRemediationItem>
      <FlexRow justify={FlexAlign.FLEX_START} gap={8}>
        <ErrorSVG width={18} height={18} />
        {GAP_TYPE_TO_LABEL[gap.getType()]}
      </FlexRow>
      {gap.getDescription()}
    </ControlGapRemediationItem>
    <ControlGapRemediationItem>
      <FlexRow justify={FlexAlign.FLEX_START} gap={8}>
        <ControlRemediationIcon />
        Corrective Action Recommendations
      </FlexRow>
      <RemediationsList remediations={gap.getRemediationsList()} />
    </ControlGapRemediationItem>
  </ControlGapRemediationContainer>
)

export const ControlGapsAndRecommendationsItem = ({
  gap,
}: {
  gap: OeControlGap
}): JSX.Element => (
  <ControlGapRemediationContainer>
    <ControlGapRemediationItem>
      <FlexRow justify={FlexAlign.FLEX_START} gap={8}>
        <ErrorSVG width={18} height={18} />
        {GAP_TYPE_TO_LABEL[gap.getType()]}
      </FlexRow>
      {gap.getDescription()}
    </ControlGapRemediationItem>
    <ControlGapRemediationItem>
      <FlexRow justify={FlexAlign.FLEX_START} gap={8}>
        <ControlRemediationIcon />
        Corrective Action Recommendations
      </FlexRow>
      {gap.getRemediation()}
    </ControlGapRemediationItem>
  </ControlGapRemediationContainer>
)

export const ControlCheckAccordionItem = ({
  controlId,
  modelId,
  controlName,
  auditRunId,
  controlChecks,
  activeKeys,
  setActiveKeys,
  isRunStillCompleting,
  isNewRun,
  liveStatuses,
}: {
  controlId: string
  modelId: string
  controlName: string
  auditRunId: string
  controlChecks: ControlTest[]
  activeKeys: string[]
  setActiveKeys: React.Dispatch<React.SetStateAction<string[]>>
  isRunStillCompleting: boolean
  isNewRun?: boolean
  liveStatuses?: OeTestStatus[]
}): JSX.Element => {
  // In-progress control: no final ControlTest rows yet, only live OE status.
  // Its row shows a spinner header + per-procedure live rows, and reconciles to
  // the normal completed row once controlChecks lands.
  const isInProgress = !controlChecks.length && !!liveStatuses?.length
  const canStartAuditRun = useCanPerformAction(CAPABILITY.CAN_START_AUDIT_SCANS)
  const [expandedChecks, setExpandedChecks] = useState<string[]>([])
  const hasCiteSources = IsGatekeeperEnabled(GatekeeperFlag.CITE_SOURCES)
  const { track, events } = useAnalytics()
  const startAuditRun = useStartAuditRun()
  const result = getCheckResult(controlChecks.map((check) => check.getResult()))
  const orderedChecks = useMemo(
    () => getOrderedControlChecks(controlChecks),
    [controlChecks],
  )
  const headerNotes = controlTestsAccordionHeaderNotes(controlId, controlChecks)
  const ready = result === AUDIT_RESULT.PASS
  const isNotApplicable = result === AUDIT_RESULT.NOT_APPLICABLE
  const hadLambdaError = result === AUDIT_RESULT.LAMBDA_ERROR
  const controlResultIcon = getCheckResultIcon(
    result,
    CHECK_RESULT_TYPE.OVERALL,
  )
  const { auditId, range } = useContext(AuditRunContext)
  const showScanAgain =
    !ready &&
    !isNotApplicable &&
    !isRunStillCompleting &&
    !isInProgress &&
    canStartAuditRun

  // Accordion event keys are keyed off the model id (invariant across the
  // live→final swap), so expansion survives results landing. The live OE
  // accordion and the eventual completed OE row share this key.
  const oeLiveKey = getControlCheckAccordionKey(
    modelId,
    CONTROL_TEST_NAMES.SPOT_CHECK,
  )

  const handleControlClick = (
    e: React.MouseEvent,
    eventKey: string,
    keys: string[],
    setActiveKeys: React.Dispatch<React.SetStateAction<string[]>>,
  ) => {
    e.preventDefault()
    e.stopPropagation()
    if (keys.includes(eventKey)) {
      keys = keys.filter((key) => key !== eventKey)
      return setActiveKeys(keys)
    }
    return setActiveKeys([...keys, eventKey])
  }

  // Toggle the live OE test accordion's expansion (its own state, separate from
  // the control-level activeKeys).
  const handleTestAccordionClick = (e: React.MouseEvent, eventKey: string) => {
    e.preventDefault()
    e.stopPropagation()
    setExpandedChecks((keys) =>
      keys.includes(eventKey)
        ? keys.filter((key) => key !== eventKey)
        : [...keys, eventKey],
    )
  }

  const scanAgain = async () => {
    track(events.C_AUDITBOT_SCAN_AGAIN, {
      auditId,
      controlId,
    })
    if (!auditId && !range) {
      return
    }
    try {
      await startAuditRun(auditId, range, [controlId])
    } catch (e) {
      log.error(
        `Error testing controls auditId ${auditId} / ${range} and controlId ${controlId}`,
        e,
      )
      showInfoToast(ToastPrompts.AUDITBOT_SCAN_ERROR)
    }
  }

  return (
    <SubsectionAccordionItemComponent
      key={modelId}
      eventKey={modelId}
      icon={
        isInProgress ? (
          isControlQueued(liveStatuses ?? []) ? (
            <OeQueuedIcon />
          ) : (
            <OeRunningSpinner />
          )
        ) : (
          controlResultIcon
        )
      }
      title={
        <AuditRunTitle
          modelId={modelId}
          text={controlName}
          route={ControlsAbsoluteRoutes.SHOW}
        />
      }
      notes={
        isInProgress ? (
          <OeHeaderNarration liveStatuses={liveStatuses ?? []} />
        ) : (
          headerNotes
        )
      }
      body={
        <>
          {isInProgress ? (
            <ControlCheckTestAccordion activeKey={expandedChecks}>
              <OeLiveTestAccordionItem
                eventKey={oeLiveKey}
                auditRunId={auditRunId}
                liveStatuses={liveStatuses ?? []}
                isExpanded={expandedChecks.includes(oeLiveKey)}
                handleClick={handleTestAccordionClick}
              />
            </ControlCheckTestAccordion>
          ) : isNotApplicable || hadLambdaError || !orderedChecks.length ? (
            <ControlCheckOtherResult result={result} />
          ) : (
            <>
              {hasCiteSources ? (
                <ControlCheckTestAccordion activeKey={expandedChecks}>
                  <ControlCheckResults
                    checks={orderedChecks}
                    controlId={controlId}
                    accordionId={modelId}
                    isNewRun={isNewRun}
                    expandedChecks={expandedChecks}
                    setExpandedChecks={setExpandedChecks}
                  />
                </ControlCheckTestAccordion>
              ) : (
                <ControlCheckResults
                  checks={orderedChecks}
                  controlId={controlId}
                  accordionId={modelId}
                  isNewRun={isNewRun}
                  expandedChecks={[]}
                  setExpandedChecks={() => []}
                />
              )}
            </>
          )}
          {showScanAgain && (
            <ScanAgainContainer>
              <TextButton onClick={scanAgain}>
                <>
                  <ScanAgainIcon />
                  Retest This Control
                </>
              </TextButton>
            </ScanAgainContainer>
          )}
        </>
      }
      handleHeaderClick={(e: React.MouseEvent) =>
        handleControlClick(e, modelId, activeKeys, setActiveKeys)
      }
      handleBodyClick={(e: React.MouseEvent) => {
        e.stopPropagation()
        e.preventDefault()
      }}
      $customGridLayout="min-content auto min-content 1fr"
    />
  )
}

export const ControlResultCounts = ({
  controlResultCounts,
}: {
  controlResultCounts: ControlResultCountsType
}): JSX.Element => {
  const resultCounts = Object.values(controlResultCounts)

  const getText = (count: number) => `${count} control${count !== 1 ? 's' : ''}`
  const getIcon = (key?: AUDIT_RESULT) => {
    if (!isNumber(key)) return null
    return getCheckResultIcon(key, CHECK_RESULT_TYPE.OVERALL)
  }
  const controlChecks = resultCounts.pop()

  return (
    <AuditBotShowControlCountsContainer>
      {resultCounts.map((elem) => (
        <AuditBotShowControlCounts key={elem.text}>
          {getIcon(elem.key)}
          {getText(elem.count)}
          {elem.text}
        </AuditBotShowControlCounts>
      ))}
      {controlChecks && (
        <SuccessfulControlTests>{`${controlChecks.count} ${controlChecks.text}`}</SuccessfulControlTests>
      )}
    </AuditBotShowControlCountsContainer>
  )
}
